export default "__VITE_ASSET__CDZjbFpl__"